import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'customDate'
})
export class CustomDatePipe implements PipeTransform {

  transform(value: any, format: string = 'DD-MM-YYYY HH:mm'): any {
    return value ? moment(value).format(format) : '';
  }

}
